/* eslint-disable */


export const ONBOARDING_STEPS_WITH_PROGRESS = {
  // CONFIRM_EMAIL: 'confirm-email',
  PERSONAL_DETAILS: 'personal-details',
  COMPLIANCE: 'compliance',
  QUESTIONNAIRE: 'questionnaire',
  PENDING_APPROVAL: 'pending-approval',
  QUICK_DEPOSIT: 'quick-deposit',
}
export const ONBOARDING_STEPS = {
  ...ONBOARDING_STEPS_WITH_PROGRESS,
  REGISTER: 'register',
  LOGIN: 'login',
  FORGOTTEN: 'forgotten',
};

export const ONBOARDING_STEP_CODE_NAME_MAP = {
  ['ConfigureProfileAndIDV']: ONBOARDING_STEPS.PERSONAL_DETAILS,
  ['ComplianceDocumentReview']: ONBOARDING_STEPS.COMPLIANCE,
  ['ComplianceQuestionReview']: ONBOARDING_STEPS.QUESTIONNAIRE,
};

export const ONBOARDING_STEP_CODES_USER_VERIFIED = [
  'SignupComplete',
  'ComplianceFinalization'
]

export const ONBOARDING_STEP_NAME_CODE_MAP = {
  PERSONAL_DETAILS: 'ConfigureProfileAndIDV',
  COMPLIANCE: 'ComplianceDocumentReview',
  QUESTIONNAIRE: 'ComplianceQuestionReview',
  ADD_FUNDS_OR_PENDING: 'RequestDeposit',
  SIGNUP_COMPLETE: 'SignupComplete',
  COMPLIANCE_FINALIZATION: 'ComplianceFinalization'
}



// WEBPACK FOOTER //
// ./src/components/onboarding/consts.js